

function getBoxCoords2(W, H, X, Y, h, from, direction) {
  var box={};

    if (from=='top') {
      box.X=X;
      box.W=W;
      box.H=h;//*H;
      box.Y=Y;//from-box.H/2;
    } 

    else if (from=='middle') {
      box.X=X;
      box.W=W;
      box.H=h;//*H;
      box.Y=(H+2*Y)/2-h*H/2;
    }

    else if (from =='bottom') {
      box.X=X;
      box.W=W;
      box.H=h;//*H;
      box.Y=(H+Y)-h*H;

    }

    else { 
      box.X=X;
      box.W=W;
      box.H=h;//*H;

      if (direction=='up') {
        box.Y=from*H-h*H+Y;
      }
      if (direction=='middle') {
        box.Y=from*(2*Y+H)-h*H/2;
      }
      if (direction=='down') {
        box.Y=from*(H)+Y;
      }

    }
    

 

  return box;

}

function getBoxCoords1(W, H, X, Y, from, h) {
  var box={};

    box.X=X;
    box.W=W;
    box.H=h;//*H;
    box.Y=from;//from-box.H/2;
 

  return box;

}


function getMinMaxLen(text) {

  var words=text.split(' ');
  var index=0;
  var maxLen=0;
  var minLen=100;
  for (let i = 0; i < words.length; i++) {
    if (words[i].length>maxLen) {maxLen=words[i].length;index=i;}
    if (words[i].length<minLen) {minLen=words[i].length;}

  }


  return [minLen, maxLen];

}

function getNumAuthors(au) {


au=(au.split( /,/ ).reduce( (a,b, i) => i %2 == 0 ? a + ";" + b : a + "," + b ) );
var authors=au.split(';');
const numAuthors=authors.length;
var authors2=[];
authors.forEach(au => {
  var temp=au.split(',');

  var auTemp='';
  if (temp[1]) {auTemp=temp[1].trim()+' '+temp[0].trim()} else {auTemp=temp[0].trim()}
  authors2.push(auTemp.trim());

});
au=authors2.join(', ');
return [au, numAuthors];

}

export default function genDesign(title,canvasWidth, canvasHeight, numLines) {
  var design={};


  const fontCombos=[
    {id:"rubik", tiFont: "Rubik Mono One", stiFont:"CormonrantGaramond", auFont:"CormonrantGaramond"},
    {id:"CormonrantGaramond", tiFont: "Cormorant Garamond", stiFont:"Cormorant Garamond", auFont:"Cormorant Garamond"},
    {id:"MontessaratFiraCode", tiFont: "Montserrat", stiFont:"Fira Code", auFont:"Fira Code"},
     {id:"OswaldQuattrocento", tiFont: "Oswald", stiFont:"Quattrocento", auFont:"Quattrocento"},
     {id:"cyborg", tiFont: "Roboto", stiFont:"Roboto", auFont:"Roboto"},
     {id: "LoraRoboto", tiFont: "Lora", stiFont:"Roboto", auFont:"Roboto"},
     {id: "PlayfairDisplaySourceSansPro", tiFont: "Playfair Display", stiFont:"Source Sans Pro", auFont:"Source Sans Pro"},
    // {id: "Neucha", tiFont: "Neucha", stiFont:"Neucha", auFont:"Neucha"},
     {id: "News", tiFont: "News Cycle", stiFont:"News", auFont:"News"},
     {id: "lux", tiFont: "Nunito Sans", stiFont:"Nunito Sans", auFont:"Nunito Sans"},
     {id: "sketch", tiFont: "'Cabin Sketch', cursive", stiFont:"Neucha", auFont:"Neucha"},
     {id: "expletus", tiFont: "Expletus Sans", stiFont:"Hind", auFont:"Hind"},
      {id: "Bubblegum", tiFont: "Bubblegum Sans", stiFont:"Open Sans", auFont:"Open Sans"},
      {id: "Mulish", tiFont: "Mulish", stiFont:"Space Mono", auFont:"Space Mono"},
      
   ];


  design.canvasWidth=canvasWidth;
  design.canvasHeight=canvasHeight;
  
  design.ti=title.title.trim();
  design.sti=title.subtitle.trim();
  design.au=title.au.trim();



var boxLayout={ti:{}, sti:{}, au:{}};

//console.log(layoutSizing);
//var area=layoutDetail.areas[Math.floor(Math.random()*layout.areas.length)];





design.tiAlign=['center','left','right'][Math.floor(Math.random()*3)];
design.tiDirection='middle';//layoutDetail.tiD;

design.stiAlign=design.tiAlign;
design.stiDirection='down';

design.auAlign=design.tiAlign;
design.auDirection='up';

design.tiCase='proper';//layoutDetail.tiCase;
design.stiCase='proper';
design.auCase='proper';




design.hPaddingStart=0;
design.hPaddingEnd=0;
design.hPaddingTop=0;
design.hPaddingBottom=0;


  

const  oneLineLayouts=[
    {W: 0.9, H: 0.9, tiA: 0.08, stiA: 0.03, auA: 0.03},




  ];

const  twoLineLayouts=[
    {W: 0.8, H: 0.9, tiA: 0.15, stiA: 0.04, auA: 0.03},

  ];

const  threeLineLayouts=[
    {W: 0.8, H: 0.9, tiA: 0.3, stiA: 0.04, auA: 0.03},


  ];

const fourLineLayouts=[
  {W: 0.7, H: 0.9, tiA: 0.25, stiA: 0.03, auA: 0.03},
  ];

const  fiveLineLayouts=[
    {W: 0.7, H: 0.9, tiA: 0.5, stiA: 0.04, auA: 0.04},
    {W: 0.7, H: 0.9, tiA: 0.5, stiA: 0.03, auA: 0.04},
    {W: 0.7, H: 0.9, tiA: 0.5, stiA: 0.04, auA: 0.03},

  ];



  var newLayout={};
  if (numLines==1) {
    newLayout=oneLineLayouts[Math.floor(Math.random()*oneLineLayouts.length)];
  } else if (numLines==2) {
    newLayout=twoLineLayouts[Math.floor(Math.random()*twoLineLayouts.length)];
  }  else if (numLines==3) {
    newLayout=threeLineLayouts[Math.floor(Math.random()*threeLineLayouts.length)];
  } else if (numLines==4) {
    newLayout=fourLineLayouts[Math.floor(Math.random()*fourLineLayouts.length)];
  } else if (numLines==5) {
    newLayout=fiveLineLayouts[Math.floor(Math.random()*fiveLineLayouts.length)];
  }  
  

  
  var mX=[0.05,0.1,0.15,0.2,0.25][Math.floor(Math.random()*5)];
  var mY=0.05;//[0.01, 0.05,0.1,0.15,0.2,0.3][Math.floor(Math.random()*6)];
 

  var lyts=[
    {type: {ti_sti_close: 0, sti_ti_close: 0, sti_au_close: 1, all_apart: 0}, ti: {direction: 'down', from: 'top', h: 0.8}, sti: {direction: 'up', from: 0.8}, au: {direction: 'up', from: 'bottom', case: 'upper'}},
  //  {type: {ti_sti_close: 1, sti_ti_close: 0, sti_au_close: 0, all_apart: 0}, ti: {direction: 'down', from: 'top', h: 0.8}, sti: {direction: 'down', from: 0.8}, au: {direction: 'up', from: 'bottom', case: 'proper'}},
    {type: {ti_sti_close: 0, sti_ti_close: 0, sti_au_close: 0, all_apart: 1}, ti: {direction: 'middle', from: 'middle', h: 0.8}, sti: {direction: 'down', from: 'top'}, au: {direction: 'up', from: 'bottom', case: 'proper'}},
    {type: {ti_sti_close: 0, sti_ti_close: 1, sti_au_close: 0, all_apart: 0}, ti: {direction: 'down', from: 0.2, h: 0.8}, sti: {direction: 'up', from: 0.18}, au: {direction: 'up', from: 'bottom', case: 'proper'}},
  //  {type: {ti_sti_close: 1, sti_ti_close: 0, sti_au_close: 0, all_apart: 0}, ti: {direction: 'down', from: 0.2, h: 0.8}, sti: {direction: 'down', from: 0.8}, au: {direction: 'up', from: 'bottom', case: 'proper'}},
      {type: {ti_sti_close: 1, sti_ti_close: 0, sti_au_close: 0, all_apart: 0}, ti: {direction: 'down', from: 0.1, h: 0.8}, sti: {direction: 'down', from: 0.1}, au: {direction: 'up', from: 'bottom', case: 'proper'}},

      // {type: {ti_sti_close: 0, sti_au_close: 1, all_apart: 0}, ti: {direction: 'down', from: 'top', h: 0.8}, sti: {direction: 'up', from: 0.88}, au: {direction: 'down', from: 0.9}},
   // {type: {ti_sti_close: 1, sti_au_close: 0, all_apart: 0},  ti: {direction: 'up', from: 0.5, h: 0.5}, sti: {direction: 'down', from: 0.5}, au: {direction: 'up', from: 'bottom'}},
   //{type: {ti_sti_close: 1, sti_au_close: 0, all_apart: 0}, ti: {direction: 'down', from: 0.1, h: 0.8}, sti: {direction: 'up', from: 0.1}, au: {direction: 'up', from: 'bottom'}},
    //{type: {ti_sti_close: 1, sti_au_close: 0, all_apart: 0}, ti: {direction: 'up', from: 0.2, h:0.2}, sti: {direction: 'down', from: 0.2}, au: {direction: 'up', from: 'bottom'}},
   // {type: {ti_sti_close: 1, sti_au_close: 0, all_apart: 0}, ti: {direction: 'up', from: 0.33, h: 0.3}, sti: {direction: 'down', from: 0.33}, au: {direction: 'up', from: 'bottom'}},
  //  {type: {ti_sti_close: 1, sti_au_close: 0, all_apart: 0}, ti: {direction: 'up', from: 0.85, h: 0.8}, sti: {direction: 'down', from: 0.85}, au: {direction: 'down', from: 'top'}},
  // {type: {ti_sti_close: 0, sti_au_close: 1, all_apart: 0}, ti: {direction: 'up', from: 'bottom', h: 0.8}, sti: {direction: 'down', from: 0.1}, au: {direction: 'up', from: 0.1}},

  ];
  var lyt=lyts[Math.floor(Math.random()*lyts.length)];
  design.tiDirection=lyt.ti.direction;
  design.stiDirection=lyt.sti.direction;
  design.auDirection=lyt.au.direction;
  design.ti_sti_close=lyt.type.ti_sti_close;
  design.sti_au_close=lyt.type.sti_au_close;
  design.all_apart=lyt.type.all_apart;
  design.sti_ti_close=lyt.type.sti_ti_close;
  design.auCase=lyt.au.case;
  //var pX=0;
  //var pY=0;
  var A=1;//(1-2*mX)*(1-2*mY);
  var tiA=newLayout.tiA;//[0.08,0.12,0.15,0.2,0.3,0.4,0.5][Math.floor(Math.random()*7)];
  var stiA=[0.1, 0.08, 0.05, 0.03][Math.floor(Math.random()*4)];
  var auA=[0.1, 0.08, 0.05, 0.03][Math.floor(Math.random()*4)];
  tiA=tiA*A;
  stiA=stiA*A;
  auA=auA*A;


  var W=1;//[0.5,0.6, 0.8,0.7,0.9][Math.floor(Math.random()*5)];
  var H=1;//[0.5,0.6, 0.7,0.8,0.9][Math.floor(Math.random()*5)];;
  W=W*(1-2*mX);
  H=H*(1-2*mY);
  design.H=Math.round(H*design.canvasHeight);
  design.W=Math.round(W*design.canvasWidth);

  var X=mX;
  var Y=mY;

  design.tiLetterSpacing=[0,3,5, 10][Math.floor(Math.random()*3)];
  if (design.tiLetterSpacing==0) {
    design.tiLineSpacingFactor=1.1;
    design.stiLetterSpacing=0;
    design.stiLineSpacingFactor=1.1;
    design.auLetterSpacing=0;
    design.auLineSpacingFactor=1.1;
  } else if (design.tiLetterSpacing==3) {
    design.tiLineSpacingFactor=1.2;
    design.stiLetterSpacing=3;
    design.stiLineSpacingFactor=1.2;
    design.auLetterSpacing=3;
    design.auLineSpacingFactor=1.2;
  }  else if (design.tiLetterSpacing==5) {
    design.tiLineSpacingFactor=1.5;
    design.stiLetterSpacing=5;
    design.stiLineSpacingFactor=1.3;
    design.auLetterSpacing=5;
    design.auLineSpacingFactor=1.3;
  } 

  var layoutSizing={tiA:{},stiA:{},auA:{}};
  layoutSizing.tiA.from=mY;//[0.1,0.2,0.15][Math.floor(Math.random()*3)];
  layoutSizing.stiA.h=stiA/W;//[0.03,0.04,0.05,0.08,0.1][Math.floor(Math.random()*5)];;
  //layoutSizing.maxTiNumLines=3;//[1,2,3][Math.floor(Math.random()*1)];;

  layoutSizing.stiA.from=layoutSizing.tiA.from+layoutSizing.tiA.h;
  
  layoutSizing.auA.h=auA/W;//[0.03,0.04,0.05,0.08,0.1][Math.floor(Math.random()*5)];;
  if (design.tiDirection=='middle') {
    layoutSizing.tiA.h=1-layoutSizing.stiA.h-layoutSizing.auA.h;//tiA/W;//[0.1,0.2,0.15,0.25,0.4,0.5][Math.floor(Math.random()*6)];;
  } else {
    layoutSizing.tiA.h=lyt.ti.h;//tiA/W;//[0.1,0.2,0.15,0.25,0.4,0.5][Math.floor(Math.random()*6)];;
  }
  layoutSizing.auA.from=1-mY-layoutSizing.auA.h;//[0.8,0.9,0.85][Math.floor(Math.random()*3)];
  layoutSizing.tiPadding=0.01;//[0,0.01, 0.05][Math.floor(Math.random()*3)];;
  layoutSizing.stiPadding=0.05;//[0.01,0.05, 0.1][Math.floor(Math.random()*3)];;
  layoutSizing.auPadding=0.01;//[0,0.1, 0.05][Math.floor(Math.random()*3)];;
  
  boxLayout.ti=getBoxCoords2(W, H, X, Y, layoutSizing.tiA.h, lyt.ti.from,lyt.ti.direction);//boxes1.box1;//boxes[layout.tiBox];//boxes1.box1;
  //console.log(boxLayout.ti);
  boxLayout.sti=getBoxCoords2(W, H, X, Y, layoutSizing.stiA.h, lyt.sti.from, lyt.sti.direction);//boxes2.box1;//boxes[layout.stiBox];//boxes3.box1;
  //console.log(boxLayout.sti);

  boxLayout.au=getBoxCoords2(W,H,X,Y,layoutSizing.auA.h, lyt.au.from, lyt.au.direction);//boxes3.box1;//boxes[layout.auBox];//boxes4.box2;
  //console.log(boxLayout.au);
//var splitRatio=splitRatios[Math.floor(Math.random()*splitRatios.length)];
//var boxes4=splitBox(boxes3.box2.W,boxes3.box2.H, boxes3.box2.X, boxes3.box2.Y, Math.random()*1 > 0 ? 0 : 1, splitRatio,layout.reverse);
//var boxes5=splitBox(boxes4.box2.W,boxes4.box2.H, boxes4.box2.X, boxes4.box2.Y, Math.random()*1 > 0 ? 0 : 1, splitRatio);




design.maxTiNumLines=layoutSizing.maxTiNumLines;

 const fontCombo=fontCombos[Math.floor(Math.random()*fontCombos.length)];
 design.tiFont=fontCombo.tiFont;
 design.stiFont=fontCombo.stiFont;
 design.suFont=fontCombo.auFont;
  //design.tiAlign=boxLayout.ti.align;//textAlignments[Math.floor(Math.random()*textAlignments.length)];
  //design.stiAlign=boxLayout.sti.align;
  //design.auAlign='right';//boxLayout.au.align;
  design.tiFontEffect='bold';//layoutDetail.tiFontEffect;//'bold';//'regular';//'bold';//fontEffects[Math.floor(Math.random()*fontEffects.length)];


  //design.tiFontSize=tiFontSizes[Math.floor(Math.random()*tiFontSizes.length)]
  design.stiFontEffect='regular';//layoutDetail.stiFontEffect;//'regular';//fontEffects[Math.floor(Math.random()*fontEffects.length)];
  //design.stiFontSize=stiFontSizes[Math.floor(Math.random()*stiFontSizes.length)]
  design.auFontEffect='regular';//layoutDetail.auFontEffect;//fontEffects[Math.floor(Math.random()*fontEffects.length)];
  //design.auFontSize=auFontSizes[Math.floor(Math.random()*auFontSizes.length)]

  design.boxLayoutId=Math.random();//W+H+tiA+stiA+auA+layout.id;//boxLayout.id;
  //design.p=boxLayout.p;

 


  design.tiX=Math.floor(boxLayout.ti.X*design.canvasWidth);//xs[Math.floor(Math.random()*3)]*design.canvasWidth;//Math.floor(boxLayout.ti.X*design.canvasWidth);
  //const tiYIndex=Math.floor(Math.random()*ys.length);
  design.tiY=Math.floor(boxLayout.ti.Y*design.canvasHeight);//ys[tiYIndex]*design.canvasHeight;//Math.floor(boxLayout.ti.Y*design.canvasHeight);
  //design.tiDirection=boxLayout.ti.direction;//'middle';//boxLayout.ti.direction;
  design.tiWidth=Math.floor(boxLayout.ti.W*design.canvasWidth);//design.canvasWidth-design.tiX;//Math.floor(boxLayout.ti.W*design.canvasWidth);
  design.tiHeight=Math.floor(boxLayout.ti.H*design.H);//Math.floor(boxLayout.ti.H*design.canvasHeight);//design.canvasHeight/4;//Math.floor(boxLayout.ti.H*design.canvasHeight);
  //design.tiX+=Math.floor(layoutSizing.tiPadding*design.tiWidth);//design.p/2*design.tiWidth;
  
  design.tiY+=Math.floor(layoutSizing.tiPadding*design.tiHeight);//design.p/2*design.tiHeight;
  
  //design.tiWidth-=Math.floor((layoutSizing.tiPadding+layoutSizing.tiPadding)*design.tiWidth);//design.p*design.tiWidth;
  design.tiHeight-=Math.floor((layoutSizing.tiPadding+layoutSizing.tiPadding)*design.tiHeight);//design.p*design.tiHeight;



  design.stiX=Math.floor(boxLayout.sti.X*design.canvasWidth);//design.tiX;//xs[Math.floor(Math.random()*3)]*design.canvasWidth;//Math.floor(boxLayout.sti.X*design.canvasWidth);
  //ys.splice(tiYIndex,1);
  //const stiYIndex=Math.floor(Math.random()*ys.length);
  design.stiY=Math.floor(boxLayout.sti.Y*design.canvasHeight);//ys[stiYIndex]*design.canvasHeight;//Math.floor(boxLayout.sti.Y*design.canvasHeight);
  //design.stiDirection=boxLayout.sti.direction;//'middle';//boxLayout.sti.direction;
  design.stiWidth=Math.floor(boxLayout.sti.W*design.canvasWidth);//design.canvasWidth-design.stiX;//Math.floor(boxLayout.sti.W*design.canvasWidth);
  design.stiHeight=Math.floor(boxLayout.sti.H*design.H);//design.canvasHeight/4;//Math.floor(boxLayout.sti.H*design.canvasHeight);
  //design.stiX+=Math.floor(layoutSizing.stiPadding*design.stiWidth);//design.p/2*design.stiWidth;
  design.stiY+=Math.floor(layoutSizing.stiPadding*design.stiHeight);//design.p/2*design.stiHeight;
  //design.stiWidth-=Math.floor((layoutSizing.stiPadding+layoutSizing.stiPadding)*design.stiWidth);//design.p*design.stiWidth;
  design.stiHeight-=Math.floor((layoutSizing.stiPadding+layoutSizing.stiPadding)*design.stiHeight);//design.p*design.stiHeight;

  //ys.splice(stiYIndex,1);

  design.auX=Math.floor(boxLayout.au.X*design.canvasWidth);//design.tiX;//xs[Math.floor(Math.random()*3)]*design.canvasWidth;//Math.floor(boxLayout.au.X*design.canvasWidth);
  design.auY=Math.floor(boxLayout.au.Y*design.canvasHeight);//ys[Math.floor(Math.random()*ys.length)]*design.canvasHeight;//Math.floor(boxLayout.au.Y*design.canvasHeight);
  //design.auDirection='up';//boxLayout.au.direction;//'middle';//boxLayout.au.direction;
  design.auWidth=Math.floor(boxLayout.au.W*design.canvasWidth);//design.canvasWidth-design.auX;//Math.floor(boxLayout.au.W*design.canvasWidth);
  design.auHeight=Math.floor(boxLayout.au.H*design.H);//design.canvasHeight/4;//Math.floor(boxLayout.au.H*design.canvasHeight);
  //design.auX+=Math.floor(layoutSizing.auPadding*design.auWidth);//design.p/2*design.stiWidth;
  design.auY+=Math.floor(layoutSizing.auPadding*design.auHeight);//design.p/2*design.stiHeight;
  //design.auWidth-=Math.floor((layoutSizing.auPadding+layoutSizing.auPadding)*design.auWidth);//design.p*design.stiWidth;
  design.auHeight-=Math.floor((layoutSizing.auPadding+layoutSizing.auPadding)*design.auHeight);


  design.label='bad';


 
  if (design.tiCase==='upper') design.ti = title.title.trim().toUpperCase();
  if (design.tiCase==='lower') design.ti = title.title.trim().toLowerCase();

  if (design.stiCase==='upper') design.sti = title.subtitle.trim().toUpperCase();
  if (design.stiCase==='lower') design.sti = title.subtitle.trim().toLowerCase();

  if (design.auCase==='upper') design.au = title.au.trim().toUpperCase();
  if (design.auCase==='lower') design.au = title.au.trim().toLowerCase();

  [design.tiMinWordLength, design.tiMaxWordLength] = getMinMaxLen(design.ti);
  [design.stiMinWordLength, design.stiMaxWordLength] = getMinMaxLen(design.sti);
  [design.auMinWordLength, design.auMaxWordLength] = getMinMaxLen(design.au);

  design.tiNumWords=design.ti.split(' ').length;
  design.stiNumWords=design.sti.split(' ').length;
  design.auNumWords=design.au.split(' ').length;

  design.tiLength=design.ti.length;
  design.stiLength=design.sti.length;
  design.auLength=design.au.length;

  if (design.stiLength ==0) {
  design.stiX=0;
  design.stiY=0;
  design.stiWidth=0;
  design.stiHeight=0;
  design.stiAlign='NA';
  design.stiDirection='NA';
  design.stiFontSize=0;
  }


  if (design.auLength == 0 ) {
  design.auX=0;
  design.auY=0;
  design.auWidth=0;
  design.auHeight=0;
  design.auAlign='NA';
  design.auDirection='NA';
  design.auFontSize=0;
  }
  [design.au, design.numAuthors] = getNumAuthors(design.au);

  
  return design;

}

